import React from 'react';

import { Course, Path, Video } from '@edx/graphql/generated';

import { CoursePathItem, VideoPathItem } from './components';

type Props = {
  path: Path;
};

export const PathFeed: React.FC<Props> = ({ path }) => {
  const [expandedItem, setExpandedItem] = React.useState<string>();
  let iteration = 0;

  const handleToggleVisibility = (itemId: string): void =>
    setExpandedItem(itemId === expandedItem ? undefined : itemId);

  return (
    <article>
      <div
        className="prose prose-dark space-y-2 text-body-large text-gray-500 border-t border-gray-600 border-opacity-50 px-4 md:px-6 py-10"
        dangerouslySetInnerHTML={{ __html: path.bodyHTML }}
      />

      <div>
        {path.items.map((item) => {
          iteration += !item.bodyHTML ? 1 : 0;
          const isCourse = item.patheable?.__typename === 'Course';
          const FeedItem = isCourse ? CoursePathItem : VideoPathItem;

          return item.bodyHTML ? (
            <div
              key={item.id}
              data-testid="feedItem"
              className="prose prose-dark space-y-2 text-body-large text-gray-500 border-t border-gray-600 border-opacity-50 px-4 md:px-6 py-10"
              dangerouslySetInnerHTML={{ __html: item.bodyHTML }}
            />
          ) : (
            <FeedItem
              key={item.id}
              item={item.patheable as Course | Video}
              position={iteration}
              {...(isCourse && {
                isExpanded: expandedItem === item.id,
                onToggleVisibility: (): void => handleToggleVisibility(item.id),
              })}
            />
          );
        })}
      </div>
    </article>
  );
};
